// React i hooks
import { memo } from "react";
import { DocumentDetailCardProps } from "./types";
import ContractSaleTemplateCard from "./components/ContractSaleTemplateCard/ContractSaleTemplateCard";
import ContractRentTemplateCard from "./components/ContractRentTemplateCard/ContractRentTemplateCard";
import OfferSaleCard from "./components/OfferSaleCard/OfferSaleCard";
import ContractSaleCard from "./components/ContractSaleCard/ContractSaleCard";
import { Divider } from "ui/components/Divider";
import InvoiceCard from "./components/InvoiceCard/InvoiceCard";


const DocumentDetailCard: React.FC<DocumentDetailCardProps> = () => {

  return (
    <>
      <OfferSaleCard />
      <Divider />
      <ContractSaleCard />
      <ContractSaleTemplateCard />
      <ContractRentTemplateCard />
      <Divider />
      <InvoiceCard />
    </>
  );
};
export default memo(DocumentDetailCard);
